(function () {
  'use strict';
  angular
    .module('com.module.reporting')
    .run(function ($rootScope, gettextCatalog) {
        
    });

})();
